import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { interval } from 'rxjs/observable/interval';
import { JwtUtils } from '../../../auth/utilities/jwtUtils';
import { Subject } from 'rxjs/Subject';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { filter, takeUntil } from 'rxjs/operators';
import { LocalStorageKeys } from '../../constants/localStorageKeys.enum';

@Component({
  selector: 'app-session-timer',
  templateUrl: './session-timer.component.html',
  styleUrls: ['./session-timer.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SessionTimerComponent implements OnInit, OnDestroy {
  remainingTime = '---';
  unsubscribe: Subject<void> = new Subject<void>();
  constructor() { }

  ngOnInit() {
    this.initializeTimer();
  }

  ngOnDestroy(): void {
      this.unsubscribe.next();
  }

  initializeTimer() {
    const sessionExpiration = interval(1000);

    sessionExpiration
      .pipe(
        takeUntil(this.unsubscribe)
      )
      .subscribe(() => {
        const totalSeconds = JwtUtils.secondsUntilTokenExpires;
        if (totalSeconds < 0) {
          return this.remainingTime = '00:00:00';
        }

        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = Math.floor(totalSeconds % 60);

        const hoursText = `${hours < 0 ? 0 : hours.toString().padStart(2, '0')}`;
        const minutesText = `${minutes < 0 ? 0 : minutes.toString().padStart(2, '0')}`;
        const secondsText = `${seconds < 0 ? 0 : seconds.toString().padStart(2, '0')}`;
        this.remainingTime = hours > 0
          ? `${hoursText}:${minutesText}:${secondsText}`
          : `${minutesText}:${secondsText}`;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/core/components/session-timer/session-timer.component.ts